import React from "react";
import CustomButton from "../CustomButton";
import { useNavigate } from "react-router-dom";
import { SvgIconType } from "../../helpers/SvgIcon";

function FormButtons({
  goBackLabel,
  goNextLabel,
  handleGoBack,
  handleGoNext,
  nextButtonDisabled,
  nextButtonLoading,
  nextButtonType = "submit",
  nextButtonIcon,
}: {
  goBackLabel?: string;
  goNextLabel?: string;
  handleGoBack?: () => void;
  handleGoNext?: () => void;
  nextButtonDisabled?: boolean;
  nextButtonLoading?: boolean;
  nextButtonType?: "submit" | "button";
  nextButtonIcon?: SvgIconType;
}) {
  const navigate = useNavigate();

  const goBack = () => {
    if (handleGoBack) {
      handleGoBack();
      return;
    }
    navigate(-1);
  };

  return (
    <div className="mt-6 flex justify-between">
      {goBackLabel && (
        <CustomButton variant="outlined" className="mr-2" onClick={goBack}>
          {goBackLabel}
        </CustomButton>
      )}
      {goNextLabel && (
        <CustomButton
          icon={nextButtonIcon}
          variant="contained"
          className="mr-2"
          type={nextButtonType}
          disabled={nextButtonDisabled}
          loading={nextButtonLoading}
          onClick={handleGoNext}>
          {goNextLabel}
        </CustomButton>
      )}
    </div>
  );
}

export default FormButtons;
